var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "bjTable-2022-2-23-16-56-17" },
    [
      _c(
        "vxe-table",
        {
          directives: [
            {
              name: "loading",
              rawName: "v-loading",
              value: _vm.loading,
              expression: "loading",
            },
          ],
          key: _vm.mainTableKey,
          ref: "ElTable",
          attrs: {
            id: _vm.mainTableKey,
            size: "mini",
            data: _vm.list,
            "max-height": _vm.autoTableHeight,
            height: _vm.height,
            stripe: _vm.stripe,
            border: _vm.border,
            "row-style": _vm.rowStyle,
            "row-class-name": _vm.rowClassName,
            "radio-config": _vm.cptRadioConfig,
            "checkbox-config": _vm.cptCheckbox,
            "tree-config": _vm.cptTreeConfig,
            "header-cell-style": _vm.$rowStyle.DEFAULT,
            "cell-class-name": _vm.cellClassName,
            "span-method": _vm.spanMethod,
            "sort-config": {
              multiple: true,
              remote: true,
              defaultSort: _vm.defaultSort,
            },
            "menu-config": _vm.cptMenuConfig,
            "column-config": { resizable: true, useKey: true },
            "row-config": { keyField: _vm.cptRowKeys, height: _vm.rowHeight },
            "tooltip-config": _vm.tooltipConfig,
            "empty-text": _vm.vm.$t("table.emptyText"),
          },
          on: {
            "radio-change": _vm.handleRadioChange,
            "checkbox-all": _vm.handleSelectAllEvent,
            "checkbox-change": _vm.handleSelectionChange,
            "resizable-change": _vm.handleHeaderDragend,
            "header-cell-menu": _vm.handleHeaderContextmenu,
            "sort-change": _vm.sortChange,
            "header-click": _vm.headerClick,
          },
        },
        [
          _vm.cptTreeNode && !_vm.serial
            ? _c("vxe-column", {
                attrs: { align: "center", width: "60", "tree-node": "" },
              })
            : _vm._e(),
          _vm.serial && !_vm.cptTreeNode
            ? _c("vxe-column", {
                attrs: {
                  type: "seq",
                  align: "center",
                  title: "table.countText",
                  width: _vm.serialWidth || "60",
                  fixed: _vm.serialFixed,
                },
              })
            : _vm._e(),
          _vm.serial && _vm.cptTreeNode
            ? _c("vxe-column", {
                attrs: {
                  type: "seq",
                  align: "center",
                  title: "table.countText",
                  width: _vm.serialWidth || "80",
                  fixed: _vm.serialFixed,
                  "tree-node": "",
                },
              })
            : _vm._e(),
          _vm.radio
            ? _c("vxe-column", {
                attrs: {
                  type: "radio",
                  align: "center",
                  title: _vm.vm.$t("selectText"),
                  width: "60",
                },
              })
            : _vm._e(),
          _vm.selection
            ? _c("vxe-column", {
                attrs: { type: "checkbox", align: "center", width: "55" },
              })
            : _vm._e(),
          _vm._t("tableColumn"),
        ],
        2
      ),
      _vm.cptIsPagination
        ? _c(
            "pagination",
            {
              ref: "pagination",
              attrs: {
                "auto-scroll": _vm.autoScroll,
                total: _vm.pagingInfo.total,
                page: _vm.pagingInfo.page,
                limit: _vm.pagingInfo.size,
                "page-sizes": _vm.pageSizes,
              },
              on: {
                "update:page": function ($event) {
                  return _vm.$set(_vm.pagingInfo, "page", $event)
                },
                "update:limit": function ($event) {
                  return _vm.$set(_vm.pagingInfo, "size", $event)
                },
                pagination: _vm.getList,
              },
            },
            [
              _c(
                "template",
                { slot: "paginationLeft" },
                [_vm._t("paginationLeft")],
                2
              ),
              _c(
                "template",
                { slot: "paginationRight" },
                [_vm._t("paginationRight")],
                2
              ),
            ],
            2
          )
        : _vm._e(),
      _vm._t("paginationBottom"),
      (_vm.selection || _vm.radio) && _vm.showTags
        ? _c(
            "div",
            { staticClass: "tags" },
            [
              _vm._l(_vm.tags, function (tag, index) {
                return _c(
                  "el-tag",
                  {
                    key: index,
                    attrs: { closable: _vm.tagsClosable },
                    on: {
                      close: function ($event) {
                        return _vm.handleTagClose(tag, index)
                      },
                    },
                  },
                  [
                    _vm._v(
                      " " +
                        _vm._s(
                          tag[_vm.tagName] ||
                            tag.skuName ||
                            tag.spuName ||
                            tag.wareName ||
                            tag.realName ||
                            tag.groupName ||
                            tag.code ||
                            tag.webReference ||
                            tag.billCategoryName
                        ) +
                        " "
                    ),
                    _vm.tagX
                      ? _c("span", [_vm._v(" x " + _vm._s(tag.count) + " ")])
                      : _vm._e(),
                  ]
                )
              }),
              _vm.tags.length > 0 && this.selection && this.tagsClosable
                ? _c(
                    "el-button",
                    {
                      staticClass: "xs",
                      attrs: { type: "info", icon: "el-icon-delete" },
                      on: { click: _vm.handleAllTagsClose },
                    },
                    [_vm._v(_vm._s(_vm.vm.$t("emptyText")))]
                  )
                : _vm._e(),
            ],
            2
          )
        : _vm._e(),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }